if (!window.webshop) window.webshop = {}
if (!tuduno.boot) tuduno.boot = {}
